"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewSavedCardsButton = ViewSavedCardsButton;
var _react = _interopRequireDefault(require("react"));
var _elements = require("@reservamos/elements");
var _reactI18next = require("react-i18next");
/** Render the same compact saved-card list action as the reference checkout. */
function ViewSavedCardsButton(_ref) {
  var extraCount = _ref.extraCount,
    onClick = _ref.onClick;
  var _useTranslation = (0, _reactI18next.useTranslation)('purchase'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "overflow-hidden rounded-xl border border-gray-200 bg-white",
    "data-sentry-component": "ViewSavedCardsButton",
    "data-sentry-source-file": "ViewSavedCardsButton.tsx"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: onClick,
    className: "flex min-h-[66px] w-full items-center justify-between bg-white px-[18px] py-3 transition-colors duration-150 hover:bg-gray-50"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex min-w-0 flex-1 items-center gap-3"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full border border-gray-100 bg-white"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Icon, {
    type: "CreditCard",
    size: "S",
    color: "discount",
    "data-sentry-element": "Icon",
    "data-sentry-source-file": "ViewSavedCardsButton.tsx"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "min-w-0 text-left text-sm font-medium leading-tight text-gray-500"
  }, t('label.view_all_saved_cards'), extraCount > 0 && /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-1 text-gray-400"
  }, "(+", extraCount, ")"))), /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-gray-100"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Icon, {
    type: "ChevronRight",
    size: "XS",
    color: "grayLight",
    "data-sentry-element": "Icon",
    "data-sentry-source-file": "ViewSavedCardsButton.tsx"
  }))));
}